import { uuid } from "uuidv4"

const uniqueHash = () => {
    return uuid();
}

export default uniqueHash;